/**
 * v0.1.174 (Sercan, 12 Oct 2026, after ChatGPT's review of the outreach plan): the first outreach waves go only to a
 * firm's generic business addresses (info@, sales@ ...), the kind a business publishes on its contact page for
 * enquiries. Australia's Spam Act (Schedule 2, clause 4) and New Zealand's UEM Act infer consent from a conspicuously
 * published address only when the message relates to the recipient's business or role; a role address on the contact
 * page is the clearest case, a person's own address found deeper on a site the least clear. Personal addresses wait
 * until Sercan decides otherwise (config/policies.yaml outreach.address_policy).
 */
/** Local parts of generic business addresses (lower case, compared before any "+tag"). */
export const GENERIC_LOCAL_PARTS = Object.freeze([
    'info',
    'sales',
    'enquiries',
    'enquiry',
    'inquiries',
    'inquiry',
    'contact',
    'contactus',
    'admin',
    'office',
    'hello',
    'service',
    'services',
    'parts',
    'shop',
    'store',
    'team',
    'mail',
    'support',
    'orders',
    'workshop',
    'fabrication',
    'quotes',
    'quote',
    'bookings',
    'reception',
]);
/** True when the address's local part (before any "+tag") is a generic business address. */
export function isGenericBusinessAddress(address) {
    const at = address.lastIndexOf('@');
    if (at <= 0)
        return false;
    const local = address.slice(0, at).toLowerCase().split('+')[0] ?? '';
    return GENERIC_LOCAL_PARTS.includes(local);
}
/** The same rule as a case-insensitive Postgres regular expression for "address ~* pattern". */
export const GENERIC_ADDRESS_PATTERN = `^(${GENERIC_LOCAL_PARTS.join('|')})(\\+[^@]*)?@`;
/** The pattern a query uses for a policy: every address matches under "any". */
export function addressPolicyPattern(policy) {
    return policy === 'generic_only' ? GENERIC_ADDRESS_PATTERN : '.';
}
//# sourceMappingURL=address-kind.js.map